<template>
  <div class="page-wrapper state4">
    <el-header class="page-header">
      <div class="table-header-box">
        <div class="section-title">作业任务</div>
        <div class="search-left">
          <el-input
            v-model="searchQuery"
            placeholder="请输入练习名称关键字"
            class="search-input"
            clearable
          >
            <el-button slot="append" icon="el-icon-search"></el-button>
          </el-input>
        </div>
      </div>
    </el-header>

    <el-main class="page-main">
      <div class="table-container">
        <el-table
          v-loading="loading"
          element-loading-text="正在加载数据..."
          :data="filteredTaskList"
          style="width: 100%"
          height="100%"
          :row-class-name="getCellIndex"
          highlight-current-row
          stripe
          :border="false"
          :header-cell-style="{
            background: '#f8fafc',
            color: '#475569',
            fontWeight: 'bold'
          }"
        >
          <el-table-column label="练习名称" min-width="150">
            <template slot-scope="scope">
              <span class="task-name"> {{ scope.row.teachingTask.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="课程名称" min-width="150">
            <template slot-scope="scope">
              <span class="course-name"> {{ scope.row.coursesName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" min-width="180">
            <template slot-scope="scope">
              <span> {{ scope.row.teachingTask.createTime }}</span>
            </template>
          </el-table-column>

          <el-table-column label="正确率" width="120">
            <template slot-scope="scope">
              <span class="accuracy-text">{{
                scope.row.teachingTaskStudent.objectiveCorrectRate + "%"
              }}</span>
            </template>
          </el-table-column>

          <el-table-column label="状态" width="120" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.teachingTaskStudent.taskStudentState === 1">
                <span class="status-tag status-success">待完成</span>
              </div>
              <div
                v-else-if="
                  [2, 4].includes(
                    scope.row.teachingTaskStudent.taskStudentState
                  )
                "
              >
                <span class="status-tag status-success">待批改</span>
              </div>
              <div
                v-else-if="scope.row.teachingTaskStudent.taskStudentState === 3"
              >
                <span class="status-tag status-success">已完成</span>
              </div>
              <div
                v-else-if="
                  scope.row.teachingTaskStudent.taskStudentState === -2
                "
              >
                <span class="status-tag status-error">缺交</span>
              </div>
              <div
                v-else-if="
                  scope.row.teachingTaskStudent.taskStudentState === -1
                "
              >
                <span class="status-tag status-info">已取消</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="150" align="center">
            <template slot-scope="scope">
              <div class="operation-column">
                <el-button
                  v-if="scope.row.teachingTaskStudent.taskStudentState === 1"
                  size="mini"
                  type="primary"
                  @click="beginWorkLisk(scope.row)"
                  >开始练习</el-button
                >
                <el-button
                  v-else-if="
                    ![1, -1, -2].includes(
                      scope.row.teachingTaskStudent.taskStudentState
                    )
                  "
                  size="mini"
                  class="analysis-btn"
                  @click="getworkList(scope.row)"
                  >查看解析</el-button
                >
              </div>
            </template>
          </el-table-column>
          <template slot="empty">
            <el-empty description="暂无作业任务"></el-empty>
          </template>
        </el-table>
      </div>
    </el-main>
  </div>
</template>

<script>
import { getOwnTaskList } from "@/api/student";

export default {
  name: "TaskIndex",
  components: {},
  data() {
    return {
      taskList: [],
      searchQuery: "",
      show: 0,
      loading: false
    };
  },
  computed: {
    filteredTaskList() {
      if (!this.searchQuery) return this.taskList || [];
      const query = this.searchQuery.toLowerCase();
      return (this.taskList || []).filter(
        item =>
          (item.teachingTask &&
            item.teachingTask.name &&
            item.teachingTask.name.toLowerCase().includes(query)) ||
          (item.coursesName && item.coursesName.toLowerCase().includes(query))
      );
    }
  },
  mounted() {
    this.loadTaskList();
  },
  methods: {
    async loadTaskList() {
      this.loading = true;
      let data = {
        type: 0,
        studentId: JSON.parse(localStorage.getItem("userInfo")).studentId
      };
      this.taskList = [];
      await getOwnTaskList(data)
        .then(res => {
          let List = res.data || [];
          List.map(val => {
            val.teachingTaskStudentInfos.map(item => {
              item.coursesName = val.coursesName || "未知课程";
              item.teachingTaskStudent.objectiveCorrectRate = (
                item.teachingTaskStudent.objectiveCorrectRate * 100
              ).toFixed(2);
              this.taskList.push(item);
            });
          });
          this.taskList.sort((a, b) => {
            return b.teachingTask.id - a.teachingTask.id;
          });
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getCellIndex({ row, rowIndex }) {
      row.index = rowIndex;
      if (row.score != "") {
        return "success-row";
      } else {
        return "warning-row";
      }
    },
    beginWorkLisk(row) {
      this.$router.push({
        path: `/workTest/${row.teachingTask.id}`,
        query: {
          title: row.teachingTask.name,
          analysis: "0"
        }
      });
    },
    getworkList(row) {
      this.$router.push({
        path: `/workhistory/${row.teachingTask.id}`,
        query: { title: row.teachingTask.name, analysis: 1 }
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/examination-page.scss";

.page-wrapper {
  background-color: #f5f7fa;
  height: calc(100vh - 64px);
  display: flex;
  flex-direction: column;
  padding: 20px;
  box-sizing: border-box;
  overflow: hidden;
}

.page-header {
  background: #fff;
  border-radius: 8px;
  padding: 16px 24px;
  margin-bottom: 16px;
  height: auto !important;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  flex-shrink: 0;
}

.page-main {
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.table-container {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.table-header-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.search-input {
  width: 400px;

  ::v-deep .el-input__inner {
    border-radius: 4px 0 0 4px;
    height: 40px;
  }

  ::v-deep .el-input-group__append {
    background-color: #f5f7fa;
    border-radius: 0 4px 4px 0;
    padding: 0 20px;

    .el-button {
      margin: -10px -20px;
      padding: 12px 20px;
      border-radius: 0 4px 4px 0;
    }
  }
}

.status-tag {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;

  &.status-todo {
    background: #f1f5f9;
    color: #64748b;
  }

  &.status-pending {
    background: #fffbeb;
    color: #d97706;
  }

  &.status-success {
    background: #f0fdf4;
    color: #16a34a;
  }

  &.status-error {
    background: #fef2f2;
    color: #dc2626;
  }

  &.status-info {
    background: #f8fafc;
    color: #94a3b8;
  }
}

.analysis-btn {
  background: white;
  border: 1px solid #dcdfe6;
  color: #606266;

  &:hover {
    color: #409eff;
    border-color: #c6e2ff;
    background-color: #ecf5ff;
  }
}

.task-name {
  color: #1e293b;
  font-weight: 500;
}

.course-name {
  color: #64748b;
}

.accuracy-text {
  font-family: "Inter", sans-serif;
  font-weight: 600;
  color: #2563eb;
}
</style>
